{
  "earnest-and-commissions": "Earnest & Commissions",
  "earnest": "Earnest",
  "commission": "Commission",
  "none": "None",
  "listing-agent": "Listing Agent",
  "returned-to-buyer": "Returned to Buyer",
  "seller": "Seller",
  "buyers-attorney": "Buyer’s Attorney",
  "sellers-attorney": "Seller’s Attorney",
  "settlement-agency": "Settlement Agency",
  "selling-agent": "Selling Agent",
  "option-fee": "Option Fee",
  "empty-entries": "There are no entries. Please select a property and add a new one.",
  "delete-entry-title": "Delete entry",
  "delete-entry-description": "This entry will be removed from the purchase price. This action cannot be undone."
}
